import { Component, Input, OnInit } from '@angular/core';
import { UtilService } from '../../shared/services';
import { SUCCESS_STORIES } from './success-stories-data';

@Component({
  selector: 'app-success-stories',
  templateUrl: './success-stories.component.html',
  styleUrls: ['./success-stories.component.scss']
})
export class SuccessStoriesComponent implements OnInit {
  @Input() config;

  DEFAUL_CONFIG = {
    currency: 'INR',
    title: 'Sucess Stories',
    successSlideCount: 3,
    stories: [],
    theme: ''
  };

  breakpoints = {
    2440: { perView: 3, gap: 20, animationDuration: 1000 },
    767: { perView: 1, gap: 30, autoplay: 4000, animationDuration: 1500 }
  };

  isMobile;

  constructor(
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util.isMobile();
    this.config = { ...this.DEFAUL_CONFIG, ...this.config };
    if (this.config?.theme) {
      this.config.stories = SUCCESS_STORIES;
      this.breakpoints[767].perView = 1.1;
      this.breakpoints[767].gap = 15;
      if (this.config?.theme?.match('2')) {
        this.breakpoints[2440].perView = 1;
      }
    }
    this.config.stories = this.config.stories.slice(0, this.config.successSlideCount);
  }

}
